var __jsx = React.createElement;
import React from "react";
import { jsx as ___EmotionJSX } from "@emotion/core";
const EuropeanUnion = () => {
  return ___EmotionJSX("svg", {
    fill: "none",
    height: "15",
    viewBox: "0 0 20 15",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg"
  }, ___EmotionJSX("mask", {
    height: "15",
    id: "mask0_305_22347",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    },
    width: "20",
    x: "0",
    y: "0"
  }, ___EmotionJSX("rect", {
    fill: "white",
    height: "15",
    width: "20"
  })), ___EmotionJSX("g", {
    mask: "url(#mask0_305_22347)"
  }, ___EmotionJSX("path", {
    clipRule: "evenodd",
    d: "M0 0V15H20V0H0Z",
    fill: "#F7FCFF",
    fillRule: "evenodd"
  }), ___EmotionJSX("mask", {
    height: "15",
    id: "mask1_305_22347",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    },
    width: "20",
    x: "0",
    y: "0"
  }, ___EmotionJSX("path", {
    clipRule: "evenodd",
    d: "M0 0V15H20V0H0Z",
    fill: "white",
    fillRule: "evenodd"
  })), ___EmotionJSX("g", {
    mask: "url(#mask1_305_22347)"
  }, ___EmotionJSX("path", {
    clipRule: "evenodd",
    d: "M0 0V15H20V0H0Z",
    fill: "#3D58DB",
    fillRule: "evenodd"
  }), ___EmotionJSX("path", {
    clipRule: "evenodd",
    d: "M9.40558 2.21035L9.26526 3.02848L9.99999 2.64221L10.7347 3.02848L10.5944 2.21035L11.1888 1.57126H10.3674L9.99999 0.767212L9.63263 1.57126H8.81117L9.40558 2.21035ZM9.40558 13.0659L9.26526 13.884L9.99999 13.4978L10.7347 13.884L10.5944 13.0659L11.1888 12.4268H10.3674L9.99999 11.6228L9.63263 12.4268H8.81117L9.40558 13.0659ZM3.48299 8.51126L3.62331 7.69313L3.0289 7.05404H3.85036L4.21772 6.24999L4.58509 7.05404H5.40654L4.81213 7.69313L4.95245 8.51126L4.21772 8.12499L3.48299 8.51126ZM4.83453 10.2813L4.69421 11.0994L5.42894 10.7132L6.16367 11.0994L6.02335 10.2813L6.61776 9.64222H5.79631L5.42894 8.83817L5.06158 9.64222H4.24012L4.83453 10.2813ZM13.8433 11.0994L13.9837 10.2813L13.3892 9.64222H14.2107L14.5781 8.83817L14.9454 9.64222H15.7669L15.1725 10.2813L15.3128 11.0994L14.5781 10.7132L13.8433 11.0994ZM4.83453 5.0376L4.69421 5.85573L5.42894 5.46946L6.16367 5.85573L6.02335 5.0376L6.61776 4.39851H5.79631L5.42894 3.59446L5.06158 4.39851H4.24012L4.83453 5.0376ZM13.8433 5.85573L13.9837 5.0376L13.3892 4.39851H14.2107L14.5781 3.59446L14.9454 4.39851H15.7669L15.1725 5.0376L15.3128 5.85573L14.5781 5.46946L13.8433 5.85573ZM6.66009 12.3637L6.51977 13.1818L7.2545 12.7956L7.98923 13.1818L7.84891 12.3637L8.44332 11.7246H7.62186L7.2545 10.9206L6.88713 11.7246H6.06568L6.66009 12.3637ZM12.0774 13.1818L12.2177 12.3637L11.6233 11.7246H12.4448L12.8121 10.9206L13.1795 11.7246H14.001L13.4065 12.3637L13.5469 13.1818L12.8121 12.7956L12.0774 13.1818ZM6.51977 3.74009L7.2545 3.35382L7.98923 3.74009L7.84891 2.92195L8.44332 2.28286H7.62186L7.2545 1.47882L6.88713 2.28286H6.06568L6.66009 2.92195L6.51977 3.74009ZM12.0774 3.74009L12.2177 2.92195L11.6233 2.28286H12.4448L12.8121 1.47882L13.1795 2.28286H14.001L13.4065 2.92195L13.5469 3.74009L12.8121 3.35382L12.0774 3.74009ZM15.1401 7.61923L14.9997 8.43737L15.7345 8.0511L16.4692 8.43737L16.3289 7.61923L16.9233 6.98014H16.1018L15.7345 6.1761L15.3671 6.98014H14.5456L15.1401 7.61923Z",
    fill: "#FFD018",
    fillRule: "evenodd"
  }))));
};
export default EuropeanUnion;
//# sourceMappingURL=EuropeanUnion.js.map
// @zapier/checkout@7.9.7 (23abc9ace)
